const defaultQuoteEventPreferences = () => ({
  eventConfig: { mode: "CONFIGURE_LATER" },
  fixedTimes: [] as string[],
  bufferedTimes: [] as unknown[],
});

export function buildQuoteAdvanced(frontPayload) {
  const { sectorWorkflow, eventScheduler } = frontPayload;

  const { averagePeople, category, places, service, areas, otherAreas, objects, specialRequests, costOverride, serviceNameOverride, frequencyType } =
    sectorWorkflow ?? {};

  return {
    scopeOfWork: {
      serviceNameOverride: serviceNameOverride?.trim() || null,

      costOverride: {
        currency: costOverride?.currency ?? "USD",
        value: costOverride?.value ?? 0,
        by: costOverride?.by ?? "per_item",
      },

      category: {
        uid: category.uid,
        type: category?.name.toLowerCase(),
      },

      squareFootage: sectorWorkflow?.squareft,

      typeOfPlace: {
        uid: places.uid,
        name: places.name,
        description: places.description,
      },

      typeOfService: {
        uid: service.uid,
        name: service.name,
        description: service.description,
        costBias: service?.costBias ?? null,
        baseRatePerHour: service?.baseRatePerHour ?? null,
      },

      areas: (areas ?? []).map((area) => ({
        uid: area.uid,
        name: area.name,
        description: area.description,
        imageUrl: area.imageUrl,
        baseDurationInMinutes: area.baseDurationInMinutes,
        createdAt: area.createdAt,
        updatedAt: area.updatedAt,
        quantity: Number(area.squareFootages?.[0]?.quantity ?? 0),
        squareFootages: area.squareFootages ?? [],
        typeOfServices: area.typeOfServices ?? [],
        tasks: (area.tasks ?? [])
          .filter((t) => t.active)
          .map((t) => ({
            uid: t.uid,
            name: t.name,
            description: t.description,
            note: t.note ?? "",
          })),
      })),

      otherAreas: (otherAreas ?? []).map((area) => ({
        uid: area.uid,
        name: area.name,
        description: area.description,
        imageUrl: area.imageUrl,
        baseDurationInMinutes: area.baseDurationInMinutes,
        createdAt: area.createdAt,
        updatedAt: area.updatedAt,
        quantity: Number(area.squareFootages?.[0]?.quantity ?? 0),
        squareFootages: area.squareFootages ?? [],
        typeOfServices: area.typeOfServices ?? [],
        tasks: (area.tasks ?? []).map((t) => ({
          uid: t.uid,
          name: t.name,
          description: t.description,
          note: t.note ?? "",
        })),
      })),

      additionalObjects: (objects ?? []).map((obj) => ({
        uid: obj.uid,
        name: obj.name,
        description: obj.description,
        imageUrl: obj.imageUrl,
        cost: obj.cost,
        durationInMinutes: obj.durationInMinutes,
        createdAt: obj.createdAt,
        updatedAt: obj.updatedAt,
      })),

      specialRequests: (specialRequests ?? []).map((sr) => ({
        uid: sr.uid,
        name: sr.name,
        description: sr.description,
        imageUrl: sr.imageUrl,
        createdAt: sr.createdAt,
        updatedAt: sr.updatedAt,
        specialRequestsByServices: sr.specialRequestsByServices.map((srs) => ({
          uid: srs.uid,
          specialRequestUid: srs.specialRequestUid,
          typeOfServiceUid: srs.typeOfServiceUid,
          increaseBasePricePercentage: srs.increaseBasePricePercentage ?? {},
          tags: srs.tags ?? [],
          createdAt: srs.createdAt,
          updatedAt: srs.updatedAt,
          typeOfService: {
            uid: srs.typeOfService.uid,
            name: srs.typeOfService.name,
            description: srs.typeOfService.description,
            costBias: srs.typeOfService.costBias,
            baseRatePerHour: srs.typeOfService.baseRatePerHour,
          },
        })),
      })),

      name: "Scope of work name",
      averagePeople: averagePeople != null ? Math.round(Number(averagePeople)) || 1 : 1,
      travelBufferTimeInGeneral: 30,
      frequencyType: frequencyType ?? sectorWorkflow?.frequencyType ?? "weekly",
    },

    eventPreferences:
      eventScheduler?.eventPreferences?.eventConfig?.mode != null && eventScheduler.eventPreferences.eventConfig.mode !== ""
        ? eventScheduler.eventPreferences
        : defaultQuoteEventPreferences(),
  };
}

export function buildQuotesAdvanced(frontPayloads) {
  if (!Array.isArray(frontPayloads)) return [];

  return frontPayloads.map((frontPayload) => buildQuoteAdvanced(frontPayload));
}
